import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({ commit }, days) {
    commit(types.SET_DAYS, days)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  async getStorage({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getStorage', () =>
      http.get('firm/storage', {
        params: searchOptions
      })
    )
    commit(types.SET_STORAGE, r.data)
    return r.data
  },
  async getAccount({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getAccount', () => http.get(`firm/storageAccount?firm=${firm}`))
    commit(types.SET_ACCOUNT, r.data)
    return r.data
  },
  async createStorageAccount({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'createStorageAccount', () => http.get(`firm/createStorage?firm=${firm}`))
    return r.data
  },
  async createStorageBucket({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'createStorageBucket', () => http.get(`firm/createBucket?firm=${firm}`))
    return r.data
  },
  async getBucketContents({ commit, dispatch }, data) {
    let url = `firm/bucketContents?firm=${data.firm}&path=${data.path}`
    if (data.bucket) {
      url += `&bucket=${data.bucket}`
    }
    const r = await startLoading(dispatch, 'getBucketContents', () => http.get(url))
    if (data.type) {
      if (data.type === 'attached') {
        commit(types.SET_ATTACHED, r.data)
      } else {
        commit(types.SET_BUCKET_CONTENTS, r.data)
      }
    } else {
      commit(types.SET_BUCKET_CONTENTS, r.data)
    }
    return r.data
  },
  async removeFromBucket({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'removeFromBucket', () => http.get(`firm/removeFromBucket?firm=${data.firm}&filename=${data.filename}`))
    return r.data
  },
  async getPresignedUrl({ commit, dispatch }, data) {
    let url = `firm/presignedUrl?firm=${data.firm}&filename=${data.filename}`
    if (data.folder) {
      url += `&folder=${data.folder}`
    }
    const r = await startLoading(dispatch, 'getPresignedUrl', () => http.get(url))
    return r.data
  },
  async listBuckets({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'listBuckets', () => http.get(`firm/listBuckets?firm=${firm}`))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/storage/actions.js